import { useLDClient } from 'launchdarkly-react-client-sdk';

export const PAYMENTSHUB_ROLLOUT_FLAG = 'pos.register.paymentshub.rollout';

export function usePaymentsHubRollout() {
  const ldClient = useLDClient();
  return ldClient?.variation(PAYMENTSHUB_ROLLOUT_FLAG, false);
}
